export const API_URL = process.env.REACT_APP_API_URL || '',
  SUBSCRIPTIONS_URL = process.env.REACT_APP_SUBSCRIPTIONS_URL || '',
  IMAGES_URL = process.env.REACT_APP_IMAGES_URL || '',
  FILES_URL = process.env.REACT_APP_FILES_URL || '',
  REACT_APP_URL = process.env.REACT_APP_URL || '',
  PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || '',
  MOBILE_APP_SUBSCRIPTION_IS_FREE = Boolean(process.env.REACT_APP_MOBILE_APP_SUBSCRIPTION_IS_FREE === 'true') || false
